import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../css/Categories.css";

// Sample categories
const categories = [
  "All",
  // "Blood Glucose",
  // "Blood Pressure",
  // "Blood Hemoglobin",
  // "All Products",
  "Blood Glucose",
  "Blood Pressure",
  "Blood Hemoglobin",
  "Home Health Care",
  "Primary Health Care",
  
  // "Hospital & Primary Healthcare",
];

// Sample products (you can replace this with actual data)


// Product Card Component
const ProductCard = ({ product }) => {
  return (
    <div className="card-container">
      <div className="card-inner">
        <div className="card-front">
        <Link to={product.link} className="card-link">
          <img src={product.image} alt={product.name} className="card-image" />
          <h2 className="card-titles">{product.name}</h2>
          {/* Link updated for React Router */}
          <Link to={product.link} className="read-more-button">
            Read More
          </Link>
          </Link>
        </div>
      </div>
    </div>
    
  );
};

// Categories Component
const Categories = ({ products }) => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  // Filter products by category
  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter((product) => product.category === selectedCategory);

  return (
    <div className="products-section">
      <h1 className="section-title"></h1>
      <div className="category-nav">
        {categories.map((category) => (
          <button
            key={category}
            className={selectedCategory === category ? "active-category" : ""}
            onClick={() => setSelectedCategory(category)}
          >
            {category}
          </button>
        ))}
      </div>
      <div className="grid-container">
        {filteredProducts.length > 0 ? (
          filteredProducts.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))
        ) : (
          <p className="no-products-message">
            Products Coming Soon
          </p>
        )}
      </div>
    </div>
  );
};

export default Categories;
